/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Laps_FastestInputs */

const en_ui_laps_fastest = /** @type {(inputs: Ui_Laps_FastestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fastest`)
};

const de_ui_laps_fastest = /** @type {(inputs: Ui_Laps_FastestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schnellste`)
};

/**
* | output |
* | --- |
* | "Fastest" |
*
* @param {Ui_Laps_FastestInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_laps_fastest = /** @type {((inputs?: Ui_Laps_FastestInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Laps_FastestInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_laps_fastest(inputs)
	return de_ui_laps_fastest(inputs)
});